export default {
    app_id: 100042,
    serverHost: '/api/m',
    mapKeys: {
        tencent: {
            appKey: 'QSFBZ-EPRCS-BJMOJ-6KVHT-4RMRZ-PIFVN',
            uri: 'https://apis.map.qq.com/uri/v1/',
            keyName: '分享'
        },
        baidu: {
            appKey: '32ceDSOsj0txM7yV5eEajllBxhclPILC',
            uri: 'https://api.map.baidu.com/marker'
        }
    },
    netease: {
        captchaId: '7dbe434c7764491daa9aea89c26f4836'
    },
    // 城市 服务配置 名称
    hadesKey: 'uds.hades.apollo-h5.config',
    citys: [
        { key: '110100', value: '北京市' },
        { key: '310100', value: '上海市' },
        { key: '320100', value: '南京市' },
        { key: '330100', value: '杭州市' },
        { key: '330200', value: '宁波市' },
        { key: '510100', value: '成都市' },
        { key: '500100', value: '重庆市' },
        { key: '460100', value: '海口市' },
        { key: '460200', value: '三亚市' },
        { key: '350100', value: '福州市' },
        { key: '610100', value: '西安市' },
        { key: '341000', value: '黄山市' },
        { key: '330300', value: '温州市' },
        { key: '370200', value: '青岛市' },
        { key: '120100', value: '天津市' },
        { key: '450100', value: '南宁市' },
        { key: '320300', value: '徐州市' },
        { key: '220100', value: '长春市' },
        { key: '370100', value: '济南市' },
        { key: '330700', value: '金华市' },
        { key: '210100', value: '沈阳市' },
        { key: '411000', value: '许昌市' },
        { key: '441300', value: '惠州市' },
        { key: '620100', value: '兰州市' },
        { key: '630100', value: '西宁市' },
        { key: '640100', value: '银川市' },
        { key: '650100', value: '乌鲁木齐市' },
        { key: '430100', value: '长沙市' },
        { key: '350200', value: '厦门市' },
        { key: '340200', value: '芜湖市' }
    ],
    wx_app_id: 'wx848d8a5cf90c037c',
    whitelist: ['/beyonder/api', '/arthur']
};



// WEBPACK FOOTER //
// ./src/config/index.js